// extracted by mini-css-extract-plugin
export default {"ce-delimiter":"Editor__ce-delimiter--ojlfNX"};